import { z } from 'zod'
import { E164PhoneSchema } from '../../../../@shared/infra/schemas/E164Phone.schema'
import { NotificationChannelEnum } from '../../../domain/enums/NotificationChannel.enum'
import { CreateAndUpdateNotifiedUserDto } from '../../../domain/dtos/CreateAndUpdateNotifiedUser.dto'

export const UpdateNotifieduserSchema = z
	.object({
		id: z.uuid().nonempty(),
		name: z.string(),
		email: z.email(),
		phoneNumber: E164PhoneSchema.nullable(),
		farms: z.array(z.string()).nonempty(),
		channels: z.array(z.enum(NotificationChannelEnum)).nonempty(),
		telegramChatId: z.number().int().optional(),
	})
	.transform((data) => {
		return {
			id: data.id,
			ids_areas_monitoradas_vinculadas: data.farms,
			nome: data.name,
			email: data.email,
			telefone: data.phoneNumber,
			identificador_chat_telegram: data.telegramChatId,
			canais_comunicacao: data.channels,
		} as CreateAndUpdateNotifiedUserDto
	})
